/** 网络、接口 相关配置 **/
export const config = {
  // common
  restUApiUserNewWebLoginPath: "/rest/u/api/user/new/web/login", //用户登录
  restServicePath: "/rest/service",
  restUCompanyGetCompanyInfoPath: "/rest/u/company/getCompanyInfo", // 获取用户信息
  restUGrayReleaseFeaturesPath: "/rest/u/gray/release/features", // 获取灰度功能
  restAccountUpgradeUserGuidePath: "/rest/account/upgrade/userGuide", // 获取是否显示新手引导
  ossStaticDataPath: "/0cdn/qlmBidding2_PC/constants/staticData.json", // oss初始化静态数据
  restLogoutPath: "/rest/logout", // 退出登录
  restApplicationMyApplicationControllerGetMyApplicationPath:
    "/rest/application/myApplicationController/getMyApplication", // 获取全部应用

  // 图形验证码
  restCaptchaGetPath: "/rest/captcha/get",
  restCaptchaCheckPath: "/rest/captcha/check",
  //图形验证没有登录
  restCaptchaNoLoginCheckPath: "/rest/captcha/nologin/check",
  restULoginQrCodeUnionIdLoginPath: "/rest/u/loginQrCode/getLoginQrCode", // 获取小程序二维码接口
  restULoginQrCodeGetLoginQrCodeStatePath: "/rest/u/loginQrCode/getLoginQrCodeState", // 小程序二维码轮询接口

  // 重置密码
  restUApiPcMemberGetUserInfoByUserNamePath: "/rest/u/api/pc/member/getUserInfoByUserName", // 根据用户名获取临时用户信息
  restUApiPcMemberSendSmsPath: "/rest/u/api/pc/member/send/sms", // 发送验证码
  restUApiPcMemberFindPasswordPath: "/rest/u/api/pc/member/find/password", // 手机号验证码校验
  restUApiPcMemberPhoneUpdatePasswordPath: "/rest/u/api/pc/member/phone/updatePassword", // 手机号找回密码,修改密码
  restUApiPcMemberSendEmailPath: "/rest/u/api/pc/member/send/email", // 发送邮箱验证码
  restUApiPcMemberFindPasswordEmailPath: "/rest/u/api/pc/member/findPassword/email", // 邮箱验证码校验
  restUApiPcMemberEmailUpdatePasswordPath: "/rest/u/api/pc/member/email/updatePassword", // 邮箱找回密码,修改密码
  restUpersonalUserPasswordUpdatePath: "/rest/u/personal/user/password/update", // 修改密码

  // 埋点
  userBehaviorInsertRecordWebsitePath: "/user/behavior/insertRecordWebsite", //公共埋点

  // 帮助中心
  restAccountSupplierStarSearchPath: "/rest/account/supplier/star/search", // 是否优秀供应商
  restAccountManualTree: "/rest/account/manual/tree", // 操作手册
  restAccountMytaskFeedbackPath: "/rest/account/mytask/feedback", // 意见反馈
  restAccountMytaskGetMaskStatusPath: "/rest/account/mytask/getMaskStatus", // 遮罩状态
  restAccountMytastTaskDetailPath: "/rest/account/mytask/taskDetil", // 新手任务详情
  restAccountMytastCloseMaskPath: "/rest/account/mytask/closeMask", // 关闭 新手任务 任务遮罩
  restAccountMytastAddPath: "/rest/account/mytask/add", // 完成任务

  // 搜索栏
  apiV1Path: "/api/v1",
  websiteSamejobSearchPath: "/website/samejob/search", // 同行在搜
  websiteSamejobSearchV2Path: "/website/samejob/search/v2", // 同行在搜V2
  websiteAssociationalSearchPath: "/website/associational/search/v2", // 相关热搜
  websiteSearchSolrCompanyPath: "/website/search/solr/company", // 获取相关公司
  buriedPointSearchKeywordPath: "/buried/point/search/keyword", // 关键词埋点
  websiteKeywordSearchV3Path: "/website/keyword/search/v3", //2274需求相关搜索新接口

  // 大搜内容列表
  websiteSearchSolrPath: "/website/search/solr", //搜索列表
  serviceHitRateInsertPath: "/rest/service/search/hit/rate/insert", //搜索有值需记录埋点插入搜索结果日志
  exportCustomExportPath: "/rest/account/export/customExport", //定制导出需求
  searchExportCheckPath: "/rest/account/export/searchExportCheck", //标准导出
  pushPeriodAndAcceptMailBoxPath: "/rest/account/subscribe/email/pushPeriodAndAcceptMailBox", //获取用户邮箱绑定状态
  collectControlleraddUserCollectPath: "/rest/account/collectController/addUserCollect", //收藏
  searchLogQuerySearchSortTypePath: "/rest/service/search/log/querySearchSortType", //获取列表排序信息

  //搜索相似单位相关
  restEnterpriseCompetitivenessCheckFreePopPath: "/rest/enterprise/enterprise/competitiveness/checkFreePop", //搜索相似单位，企业商情和更多联系人，添加免费试用提示。
  restEnterpriseCompetitivenessPermissionCheckPath: "/rest/enterprise/enterprise/competitiveness/permission/check", //搜索相似单位，企业商情权限（有试用次数）。
  competitivenessSimilarUnitPath: "/rest/enterprise/enterprise/competitiveness/similarUnit", //相似供应商/采购商 - 搜索
  competitivenessSimilarUnitListPath: "/rest/enterprise/enterprise/competitiveness/similarUnit/list", //相似供应商/采购商 - 搜索-列表
  contactsUserListPath: "/rest/enterprise/enterprise/contacts/user/list", //相似供应商/采购商 - 搜索-联系人列表
  contactsUserWebsiteListPath: "/rest/enterprise/enterprise/contacts/websiteList", //搜索公司 - 搜索-联系人列表
  enterpriseCompanySearchPath: "/rest/enterprise/enterprise/companySearch", //获取企业信息
  accountCollectCompanyFlagPath: "/rest/account/collect/company/flag", //搜索公司联系人是否收藏该公司
  accountCollectCompanyAddPath: "/rest/account/collect/company/add", //收藏该公司
  accountCollectCompanyDeletePath: "/rest/account/collect/company/delete", //取消收藏该公司
  websiteAdvertisementPath: "/rest/service/api/v1/website/advertisement", //搜索关键字取相关关键字公司
  competitivenessEntranceInfoPath: "/rest/enterprise/enterprise/competitiveness/entrance/info", //获取企业竞争力分析入口信息
  companyMonitorImmediatelyUsePath: "/rest/application/companyMonitor/immediatelyUse", //检查是否使用了监控加油包
  behaviorCompanyMonitorExposurePath: "/rest/user/behavior/companyMonitorExposure", //监控信息
  companyMonitorsaveCompanyMonitorPath: "/rest/application/company/monitor/saveCompanyMonitor", //添加监控
  companyMonitorlikeUsePath: "/rest/application/company/monitor/likeUse", //使用监控加油
  companyMonitorisHasUnusedFuelBagsPath: "/rest/application/company/monitor/isHasUnusedFuelBags", //判断用户是否有加油包使用
  behaviorCompanyMonitorPath: "/user/behavior/companyMonitor", //监控埋点
  dialogInfoGetCompanyMonitorInfoPath: "/rest/pay/pay/dialog/info/getCompanyMonitorInfo", //获取企业监控额度信息

  //搜索筛选条件
  classInfoSearchClassInfoPath: "/rest/service/website/search/classInfo/searchClassInfo", //获取行业分类
  searchFeedbackFourLevelPath: "/rest/service/feedback/website/search/feedbackFourLevel", //保存用户反馈行业分类

  // 行业专区
  restAccountIndustryGetBusinessCountPath: "/rest/account/industry/getBusinessCount", // 智能订阅弹窗
  restAccountIndustryQueryIsEnterPath: "/rest/account/industry/queryIsEnter", // 获取行业专区信息
  restAccountIndustrySearchPath: "/rest/account/industry/search", // 获取行业信息 - 行业专区信息栏tab切换

  //订阅相关
  restAccountSubscribeGetUserDefaultRegionPath: "/rest/account/subscribe/getUserDefaultRegion", //获取用户默认地区
  restAccountSubscriberRecommendGetPath: "/rest/account/subscriber/recommend/get", // 获取推荐的订阅器
  restAccountSubscriberRecommendQueryRecommendSubscriberPath:
    "/rest/account/subscriber/recommend/queryRecommendSubscriber", // 查询用户订阅器数量和推荐订阅器是否创建
  restAccountTenderSubscribeCreateOrUpdateSubscriberPath: "/rest/account/tender/subscribe/createOrUpdateSubscriber", // 生成订阅
  restAccountTenderSubscribeGetSubscriberListByUserIdPath: "/rest/account/tender/subscribe/getSubscriberListByUserId", // 招标订阅器列表拉取
  restAccountWillBuildSubscribeGetSubscriberListByUserIdPath:
    "/rest/account/will/build/subscribe/getSubscriberListByUserId", // 拟在建订阅器列表拉取
  restAccountApprovalSubscribeGetSubscriberListByUserIdPath:
    "/rest/account/approval/subscribe/getSubscriberListByUserId", // 审批订阅器列表拉取
  restAccountPurchaseSubscribeGetSubscriberListByUserIdPath:
    "/rest/account/purchase/subscribe/getSubscriberListByUserId", // 意向采购订阅器拉取
  restAccountPurchaseSubscribeCreateOrUpdateSubscriberPath: "/rest/account/purchase/subscribe/createOrUpdateSubscriber", // 意向采购订阅器拉取
  restAccountSubscribeSolrPurchaseKeywordNumPath: "/rest/account/subscribe/solr/purchase/keyword/num", //采购意向关键词数量

  restAccountTenderSubscribeGetSubscriberByIdPath: "/rest/account/tender/subscribe/getSubscriberById", // 招标订阅器拉取
  restAccountWillBuildSubscribeGetSubscriberByIdPath: "/rest/account/will/build/subscribe/getSubscriberById", // 拟在建订阅器拉取
  restAccountApprovalSubscribeGetSubscriberByIdPath: "/rest/account/approval/subscribe/getSubscriberById", // 审批订阅器拉取

  restAccountCompanySpaceCheckSubscribeCreatePermissionPath:
    "/rest/account/companySpace/checkSubscribeCreatePermission", // 检查订阅器创建权限
  restApiAccountSubscribeLaveSubscriberCountPath: "/rest/account/subscribe/laveSubscriberCount", // 订阅器数量
  restAccountTenderSubscribeDeletePath: "/rest/account/tender/subscribe/delete", // 删除标讯
  restAccountWillBuildSubscribeDeletePath: "/rest/account/will/build/subscribe/delete", // 删除拟建
  restAccountApprovalSubscribeDeletePath: "/rest/account/approval/subscribe/delete", // 删除审批
  restAccountPurchaseSubscribeDeletePath: "/rest/account/purchase/subscribe/delete", // 删除意向采购订阅

  restAccountSubscribeSolrListPath: "/rest/account/subscribe/solr/list", // 预览列表
  restAccountSubscribeRecommendKeywordPath: "/rest/account/subscribe/recommend/keyword", // 订阅词推荐
  restAccountSubscribeSolrListCountPath: "/rest/account/subscribe/solr/list/count", // 订阅器每一个关键词列表数量统计
  restAccountSubscribeSolrListByIdPath: "/rest/account/subscribe/solr/listById", // 新版本查询订阅器信息列表
  restAccountIndustryQueryBusinessListPath: "/rest/account/industry/queryBusinessList", // 智能订阅器 获取业务类型
  restAccountSubscribeGrayGetVersionPath: "/rest/account/subscribe/gray/getVersion", // 获取订阅器新旧版本显示形式（用户设置）
  restAccountSubscribeGrayUpdateGrayPath: "/rest/account/subscribe/gray/updateGray", // 设置订阅器新旧版本显示形式（用户设置）
  restAccountSubscribeSolrGetPurchasePath: "/rest/account/subscribe/solr/get-purchase", // 新版本查询订阅器信息列表

  //微信相关
  restMpAuthWxUnbidPath: "/rest/mp/auth/wx/unbid", // 获取微信解除绑定
  restMpAuthWxQrcodePath: "/rest/mp/auth/wx/qrcode", // 获取二维码
  restMpAuthWxCommoncodePath: "/rest/mp/auth/wx/commoncode", // 获取微信绑定二维码 ticket 获取二维码, authorize_userId => 授权
  restMpAuthWxWxinfoPath: "/rest/mp/auth/wx/wxinfo", // 根据 userId 查询微信绑定状态
  restMpAuthWxUinfoPath: "/rest/mp/auth/wx/uinfo", // 获取微信绑定信息

  // 用户管理
  restUserApiHomepageCodePath: "/user/api/homepage/getCode", //注册手机号发送验证码1.0
  restApiHomepageRegisterOrLoginPath: "/user/api/homepage/registerOrLogin", //完成注册
  restUserRegisterByPhonePath: "/rest/u/api/user/register/byphone", //活动页手机号注册
  restUserRegisterMobileCodeNewPath: "/rest/u/api/user/register/mobile/code/new", //活动页手机号注册-获取验证码
  restUserGetAuthTokenPath: "/rest/u/company/getCompanyInfo", //接口目的-获得token
  restUserRegisterCompleteInfoPath: "/rest/u/personal/members/info/update", //完善信息

  restUPersonalUserPhoneCodePath: "/rest/u/personal/user/phone/code", //手机号发送验证码
  restUPersonalUserPhoneUpdatePath: "/rest/u/personal/user/phone/update", //手机号绑定
  restAccountSubscribeEmailSendEmailVerifyCodePath: "/rest/account/subscribe/email/sendEmailCode", //邮箱绑定发送验证码   换了地址，之前的（/rest/account/subscribe/email/sendEmailVerifyCode）地址和app共用的
  restAccountSubscribeEmailSaveEmailPath: "/rest/account/subscribe/email/saveEmail", //订阅邮箱绑定
  restUPersonalUserEmailUpdatePath: "/rest/u/personal/user/email/update", // 账号绑定邮箱 绑定与换绑
  restUPersonalUserBaseinfoUpdatePath: "/rest/u/personal/user/baseinfo/update", // 修改基础信息
  restUPersonalUserCompanyinfoUpdatePath: "/rest/u/personal/user/companyinfo/update", // 修改单位信息
  restUCompanyIndustryPath: "/rest/u/company/industry", // 获取行业JSON
  restUCompanyPhoneBindStatusPath: "/rest/u/company/phone/bind/status", //查询手机号是否被绑定
  //通过行业id查询行业关键词列表
  restAccountGetKeyWordListPath: "/rest/account/industry/getKeywordList",

  //商情支付相关
  restPayDialogShowPath: "/rest/pay/pay/dialog/show", // 支付弹框曝光埋点 type 1竞争力分析弹框 2商机数据推荐 3个人中心续费弹框 4 直采支付弹框
  restEnterprisePayserviceGetCompanyCompeteShowPath: "/rest/enterprise/payservice/getCompanyCompeteShow", // 商情分析弹窗展示数据
  restPayDialogSetPhonePath: "/rest/pay/pay/dialog/set/phone", // 支付弹框记录手机号
  restPayDialogClickPaybtnPath: "/rest/pay/pay/dialog/click/paybtn", // 支付弹框点击埋点 type 1竞争力分析弹框 2商机数据推荐 3个人中心续费弹框 4 直采支付弹框
  restEnterprisePayserviceBusinessQrcodePath: "/rest/enterprise/payservice/businessQrCode", // 支付二维码及金额
  restEnterprisePayservicePayStatePath: "/rest/enterprise/payservice/payState", // 支付二维码状态

  //联系支付相关
  restEnterpriseContactsPaylogIsShowContactPayPath: "/rest/enterprise/enterprise/contacts/paylog/isShowContactPay", // 支付二维码状态
  restEnterprisePayserviceGetPayMoneyPath: "/rest/enterprise/payservice/getPayMoney", // 【更多联系人】获取金额
  restEnterprisePayservicePayQrCodePicPath: "/rest/enterprise/payservice/payQrCodePic", // 【更多联系人】获取支付二维码
  restPayPayGetPayQrCodePath: "/rest/pay/pay/getPayQrCode", // 【联系人变更通知】获取支付二维码

  //中间号相关
  virtualPhoneBindPath: "/rest/enterprise//virtual/phone/bind", //虚拟号码返回真实号码
  virtualPhoneBindStatusPath: "/rest/enterprise//virtual/phone/bind/status", //中间号电话
  virtualPhoneUnbindStatusPath: "/rest/enterprise/virtual/phone/unbind", //解绑中间号
  virtualPhoneCalledPath: "/rest/enterprise/virtual/phone/called", //获取真实号码

  restApplicationAdSupplyListPath: "/rest/application/ad/supply/list", //右侧免费用户显示的推荐供应商

  //首页用到的接口

  restAccountCompanyMonitorStatisticPath: "/rest/account/company/monitor/statistic", //首页企业监控动态统计
  restAccountCollectControllerNewConcernPath: "/rest/account/collectController/new/concern", //首页最近收藏记录
  restAccountCollectGetRecentlyCollectCompanyPath: "/rest/account/collect/getRecentlyCollectCompany", //首页收藏企业
  restULoginControllerGetUserAllQuotaPath: "/rest/u/loginController/getUserAllQuota", //首页今日查看配额

  //新手引导用到的接口
  restAccountUserTaskGradeGetTaskProgressPath: "/rest/account/userTaskGrade/getTaskProgress", //获取新手引导步骤，及是否有权限
  restAccountUserTaskGradeGetIsEjectPath: "/rest/account/userTaskGrade/getIsEject", //获取是否弹出新手引导流程
  restAccountUserTaskGradeCoreKeywordPath: "/rest/account/userTaskGrade/coreKeyword", //获取用户核心关键词
  restAccountUserTaskGradeGetIndustryInfoPath: "/rest/account/userTaskGrade/getIndustryInfo", //获取用户行业信息
  restSubscribeRecommendKeywordPath: "/rest/account/subscribe/recommend/keyword", //获取关键字推荐
  restAccountUserTaskGradeGetUserTaskPath: "/rest/account/userTaskGrade/getUserTask", //继续新手任务
  restAccountUserTaskGradeGetNextTaskPath: "/rest/account/userTaskGrade/getNextTask", //新手指导下一步
  restWebsiteSearchSolrCompanyPath: "/rest/service/website/search/solr/company", // 相似公司
  restCompanySpaceCheckNewUserPath: "/rest/account/companySpace/checkNewUser", // 是否是2.5账号

  /**发票管理相关接口 */
  restAccountV2InvoiceListPath: "/rest/account/v2/invoice/list", // 用户发票列表
  restAccountV2InvoiceApplyPath: "/rest/account/v2/invoice/apply", // 发票申请
  restAccountV2InvoiceCheckPath: "/rest/account/v2/invoice/check", // 校验订单是否可以开票
  restAccountOrderListPath: "/rest/account/order/list", // 获取订单列表

  restAccountSearchProgrammeGetProgrammesPath: "/rest/account/search/programme/getProgrammes", // 获取常用搜索列表
  restAccountSearchProgrammeDeleteProgrammePath: "/rest/account/search/programme/deleteProgramme", // 删除常用搜索
  restAccountSearchProgrammeCreateOrUpdateProgrammePath: "/rest/account/search/programme/createOrUpdateProgramme", // 保存常用搜索
  restAccountSearchGrayDisplayPath: "/rest/account/search/gray/isDisplayBid", // 找商机入口显隐
  websiteSearchSolrTender: "/website/search/solr/tender", // 招标讯搜索
  restServiceInterfaceConfigFilterModePath: "/rest/service/interface/config/filterMode", // 搜索模式是否要切换成互斥的
  restAccountExportTenderExportCheck: "/rest/account/export/tenderExportCheck", // 批量导出
  restServiceSearchHitRateTenderInsertPath: "/rest/service/search/hit/rate/tender/insert", // 搜索日志
  restServiceSearchHitRateTenderUpdate: "/rest/service/search/hit/rate/tender/update", // 更新日志

  //拟在建
  restAccountSubscribeAllIndustryTypeListBysortPath: "/rest/account/subscribe/allIndustryTypeList/bysort", // 获取项目类别可选项
  websiteSearchSolrWillbuild: "/website/search/solr/willbuild", // 找商机-列表
  willbuildExportCheck: "/rest/account/export/willbuildExportCheck", // 批量导出
  restAccountSearchGrayIsDisplayProjectPath: "/rest/account/search/gray/isDisplayProject", // 拟在建入口显隐
  restAccountSearchProgrammeGetProgrammesIsNewPath: "/rest/account/search/programme/getProgrammesIsNew", // 是否第一次添加常用搜索

  restServiceSearchHitRateWillbuildInsertPath: "/rest/service/search/hit/rate/willbuild/insert", // 搜索日志
  restServiceSearchHitRateWillbuildUpdate: "/rest/service/search/hit/rate/willbuild/update", // 详情日志

  // 审批搜索
  websiteSearchSolrApprovalPath: "/website/search/solr/approval", // 列表
  approvalExportCheckPath: "/rest/account/export/approvalExportCheck", // 批量导出
  projectAndApprovalExportCheckPath: "/rest/account/export/projectAndApprovalCheck", // 订阅信息-拟建和审批批量导出
  restServiceSearchHitRateApprovalInsertPath: "/rest/service/search/hit/rate/approval/insert", // 搜索日志
  restServiceSearchHitRateApprovalUpdatePath: "/rest/service/search/hit/rate/approval/update", // 详情日志

  //订阅信息页面商情模式

  restAccountBusinessClueListPath: "/rest/account/business/clue/list", // 订阅信息页面商情模式
  restDetailAllTypesDetailSimpleDetailPath: "/rest/detail/alltypesdetail/simple/detail", //    获取公司简单的详情数据
  restAccountExportTenderSubscriberExportCheckPath: "/rest/account/export/tenderSubscriberExportCheck", // 批量导出
  restAccountTenderSubscriberGetUserSubscribeSortPath: "/rest/account/tender/subscribe/getUserSubscribeSort", // 订阅排序方式
  restAccountTenderSubscriberGetTenderSummaryTypePath: "/rest/account/tender/subscribe/getTenderSummaryType", // 订阅明细
  restAccountTenderSubscriberDetaiClicklogPath: "/rest/account/subscribe/detail/clicklog", // 订阅日志
  restAccountSubscribeSatisfactionLogInsertPath: "/rest/account/subscribeSatisfactionLog/insert", // 订阅满意度调查
  restAccountSubscribeSatisfactionLogAboutTimeReturnChoosePath:
    "/rest/account/subscribeSatisfactionLog/aboutTimeReturnChoose", // 订阅满意度调查
  restAccountBusinessCluePermissionCheckPath: "/rest/account/business/clue/permission/check", // 订阅器权限
  restEnterpriseEnterpriseCompetitivenessCheckFreePopPath: "/rest/enterprise/enterprise/competitiveness/checkFreePop", // 订阅器免费提示

  restAccountDrainageMedicalDeviceCloudPath: "/rest/account/drainage/medicalDeviceCloud", // 判断是否展示引流的医疗云入口
  restAccountTenderSubscribeAddSubscribeSortTypePath: "/rest/account/tender/subscribe/addSubscribeSortType", // 保存排序方式 订阅
  restAccountTenderSubscribeSaveTenderSummaryTypePath: "/rest/account/tender/subscribe/saveTenderSummaryType", // 保存明细接口订阅

  restUCompanyUserListPath: "/rest/u/company/user/list", // 子账号管理
  restUCompanyUserStartPath: "/rest/u/company/user/start", // 启用子账号接口
  uCompanyUserDeletePath: "/rest/u/company/user/delete", // 删除子账号接口
  uCompanyChildUserQuotaPath: "/rest/u/company/childUser/quota", // 获取子账号额度接口
  restAccountCompanyUserShowPath: "/rest/account/company/user/show", // 是否展示弹框
  restUCompanyexpirePermissionPath: "/rest/u/company/company/user/expire/permission", // 验证主账号是否过期 code=310300 已过期。
  restUCompanyextendusagePath: "/rest/u/company/extends/quota/usage", // 获取临时额度
  //设置子账号配额
  restQuotaBatchUpdatePath: "/rest/u/company/user/quota/batchUpdate",

  //临时额度加油包支付
  restGetQuotaDialogInfoPath: "/rest/pay/pay/dialog/info/getQuotaDialogInfo", // 支付通用--获取额度支付弹框中的信息--购买浏览条数用

  restAccountManualManualDetailPath: "rest/account/manual/manualDetail", // 获取使用手册导详情

  // 会员中心 - 我的会员
  restUUserMyMemberPath: "/rest/u/user/myMember",
  // 账户安全
  restApplicationAccountsecurityListPath: "/rest/application/accountsecurity/list",
  // 获取手机号登陆信息˝
  restUPersonalLoginManageInfoPath: "/rest/u/personal/login/manage/info",
  // 关闭手机号登录
  restUPersonalPhoneLoginOffPath: "/rest/u/personal/phone/login/off",
  // 开启手机号登录
  restUPersonalPhoneLoginOnPath: "/rest/u/personal/phone/login/on",

  restULoginControllerUserLoginTimePath: "rest/u/loginController/user/logintime", // 获取登录时间
  restUApiMemberLoginSendSmsPath: "rest/u/api/member/login/send/sms", //登录发送短信接口
  restUApiMemberLoginGetUsersPath: "rest/u/api/member/login/getUsers", //获取可以手机号登录的用户类型
  restUApUserPhoneLoginPath: "rest/u/api/user/phone/login", //通过手机验证码方式登录
  restUApiUserCodeLoginPath: "/rest/u/api/user/code/login", // 快捷注册/登录接口

  restEnterpriseEnterpriseContactsListPath: "/rest/enterprise/enterprise/contacts/list", //获取联系人
  restEnterpriseContactsTenderListPath: "/rest/enterprise/enterprise/contacts/tender/list", //获取来源项目

  restAccountPopupGetLogPath: "/rest/account/popup/getLog", // 获取 sidebar 是否自动弹窗

  /**子账号购买*/
  restPayPayDialogInfoNeedBuyMoreDialogPath: "/rest/pay/pay/dialog/info/needBuyMoreDialog", //获取是否可以弹框
  restPayPayDialogInfoGetBuyMoreChildAccountDialogInfoPath:
    "/rest/pay/pay/dialog/info/getBuyMoreChildAccountDialogInfo", //获取弹框信息
  restPayPayBuyMoreGetOrderDetailPath: "/rest/pay/pay/buyMore/getOrderDetail", //查看订单详情
  restPayPayBuyMoreGetPayQrCodePath: "/rest/pay/pay/buyMore/getPayQrCode", //获取支付二维码及信息
  /**企业监控*/
  restApplicationCompanyMonitorPermissionPath: "/rest/application/company/monitor/permission", //企业监控权限
  restApplicationCompanyMonitorRecommendPath: "/rest/application/company/monitor/recommend", //推荐企业
  restAccountCompanyMonitorSolrCompanyPath: "/rest/account/company/monitor/solr/company", //推荐企业,模糊查询
  restApplicationCompanyMonitorGroupListPath: "/rest/application/company/monitor/group/list", //分组数据
  restApplicationCompanyMonitorGetCompanyNumPath: "/rest/application/company/monitor/getCompanyNum", //监控中的企业个数
  restApplicationCompanyMonitorCompanyListPath: "/rest/application/company/monitor/companyList", //获取监控企列表
  restApplicationCompanyMonitorModifyGroupPath: "/rest/application/company/monitor/modifyGroup", //修改企业分组
  restApplicationCompanyMonitorDelCompanyInfoPath: "/rest/application/company/monitor/delCompanyInfo", //删除监控企业
  restApplicationCompanyMonitorSaveCompanyMonitorWithGidPath:
    "/rest/application/company/monitor/saveCompanyMonitorWithGid", //保存监控企业

  restApplicationCompanyMonitorGetCompanyMonitorCountPath: "/rest/application/company/monitor/getCompanyMonitorCount", //获取监控企业数量
  restApplicationCompanyMonitorGetCompanyMonitorAllCountPath:
    "/rest/application/company/monitor/getCompanyMonitorAllCount", //获取可监控企业数量与已监控数量

  restApplicationCompanyMonitorGetCompanyMonitorDynamicsListPath: "/rest/application/company/monitor/msgs/list", //获取企业动态列表
  restApplicationCompanyMonitorGetCompanyMonitorDynamicsFilterPath:
    "/rest/application/company/monitor/getUserCompanyGroup", //获取企业动态列表查询条件
  restCompanyMonitorGroupAddPath: "/rest/application/company/monitor/group/add", // 新增分组
  restCompanyMonitorGroupListPath: "/rest/application/company/monitor/group/list", // 分组列表
  restCompanyMonitorGroupModifyGroupNamePath: "/rest/application/company/monitor/group/modifyGroupName", // 改分组名称
  restCompanyMonitorGroupModifyMsgTypesPath: "/rest/application/company/monitor/group/modifyMsgTypes", // 修改监控内容
  restCompanyMonitorGroupModifyEmailPushSetPath: "/rest/application/company/monitor/group/modifyEmailPushSet", // 修改邮箱推送
  restCompanyMonitorGroupModifyWechatPushSetPath: "/rest/application/company/monitor/group/modifyWechatPushSet", // 修改微信推送
  restCompanyMonitorGroupDelByIdPath: "/rest/application/company/monitor/group/delById", // 删除分组
  restAccountDictListByPinyinPath: "/rest/account/dict/listByPinyin", // 获取字典
  restCompanyMonitorFeedBackSubmitPath: "/rest/application/company/monitor/feedBack/submit", // 企业监控--提交意见反馈
  restCompanyMonitorFeedBackCheckSubmitPath: "/rest/application/company/monitor/feedBack/checkSubmit", // 企业监控--是否提交过意见反馈
  restCompanyMonitorGroupGetPushStatePath: "rest/application/company/monitor/group/getPushState", //用户如果监控了任意企业（不区分分组，含待分类），并且没有开启任何推送（任何组、任何频次、微信或邮件
  restApplicationCompanyMonitorMsgsReadPath: "rest/application/company/monitor/msgs/read", //企业监控已读标记
  restApplicationCompanyMonitorModifyGroupAllPath: "rest/application/company/monitor/modifyGroupAll", //企业监控1.批量修改分组
  restApplicationCompanyMonitorDelCompanyAllPath: "rest/application/company/monitor/delCompanyAll", //企业监控1.批量删除

  restUPersonalMembersInfoUpdatePath: "/rest/u/personal/members/info/update", //登录页完善信息接口

  //采购意向
  restWebsiteSearchSolrPurchasePath: "/rest/service/website/search/solr/purchase", //采购意向通用搜索
  restExportPurchasePath: "/rest/account/export/purchase", // 导出全部接口
  restAccountExportPurchaseClickPath: "/rest/account/export/purchase/click", // 选中导出接口
  restCollectControllerAddPurchaseCollectPath: "/rest/account/collectController/addPurchaseCollect", // 批量收藏采购意向
  restCollectControllerCancelPurchaseCollectPath: "/rest/account/collectController/cancelPurchaseCollect", // 批量移出收藏
  restApplicationPurchasePermissionInfoPath: "/rest/application/purchase/permission/info", // 用户是否领取&购买有采购意向
  restApplicationPurchasePermissionReceivePath: "/rest/application/purchase/permission/receive", // 用户免费领取采购意向
  restPayPayDialogInfoGetBuyPurchaseInfoPath: "/rest/pay/pay/dialog/info/getBuyPurchaseInfo", // 采购意向支付弹窗信息
  restAccountCompanySpaceCheckPurchaseSubPermissionPath: "/rest/account/companySpace/checkPurchaseSubPermission", // 采购意向订阅器创建权限
  restAccountExportPurchaseSubscriberExportCheckPath: "/rest/account/export/purchaseSubscriberExportCheck", // 采购意订阅导出

  // 问卷调查
  restAccountQuestionGetConditionPath: "/rest/account/question/getCondition", //获取问卷调查数据
  restAccountQuestionSubmitQuestionPath: "/rest/account/question/submitQuestion", //获取问卷调查数据

  HTTP_CODE: {
    SUCCESS: 200,
    UNAUTHORIZED: 401,
    PAYMENT_REQUIRED: 402,
    NO_AUTHORISE: 403,
    REDO_LOGIN: 406,
    TOO_FREQUENTLY_429: 429,
    TOO_FREQUENTLY_521: 521,
  },

  STATUS_CODE: {
    SUCCESS: 200,
    SERVER_ERR: 503,
    TO_SUBSCRIBE: 500500,
    REQUEST_CANCEL: "REQUEST_CANCEL",
    PERMISSION_EXPIRATION: 310300, // 权限过期
    ACCESS_CAPTCHA_PERMISSION_IS_MISSING: 200622, // 需要滑动验证刷新权限
  },
};
